import React from 'react';
import mvp2026Logo from '../assets/images/certs/mvp2026.png';

function About() {
    return (
        <div className="about-page">
            <div className="page-title">
                <div className="container">
                    <h1>About</h1>
                </div>
            </div>
            
            <section className="section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 mx-auto">
                            <div className="about-content">
                                <div className="about-intro">
                                    <h2>Welcome to My Knowledge Portal</h2>
                                    <p className="lead">
                                        Your comprehensive resource for learning Microsoft 365, SharePoint, Power Platform, and Copilot through expert video tutorials and practical guides.
                                    </p>
                                </div>

                                <div className="about-author">
                                    <div className="about-author-content">
                                        <h2>About the Author</h2>
                                        <p>
                                            <strong>Marc A. Schröder-Zhou</strong> is the creator and curator of this knowledge portal. With extensive experience in Microsoft technologies, Marc is dedicated to sharing practical knowledge and best practices to help professionals master the Microsoft 365 ecosystem.
                                        </p>
                                    </div>
                                    <div className="about-author-badge">
                                        <img src={mvp2026Logo} alt="Microsoft MVP 2026-2027" className="mvp-badge" />
                                    </div>
                                </div>

                                <div className="about-content-section">
                                    <h2>What You'll Find Here</h2>
                                    <p>
                                        This portal serves as a comprehensive learning hub for anyone looking to enhance their skills with Microsoft's collaboration and productivity tools. Our content focuses on:
                                    </p>
                                    
                                    <div className="content-topics">
                                        <div className="topic-item">
                                            <h3>SharePoint</h3>
                                            <p>
                                                Learn how to effectively use SharePoint for document management, team collaboration, and building powerful intranet solutions. Our tutorials cover everything from basic site creation to advanced customization and administration.
                                            </p>
                                        </div>

                                        <div className="topic-item">
                                            <h3>Microsoft 365 (M365)</h3>
                                            <p>
                                                Discover the full potential of Microsoft 365 suite. Explore integrated workflows, security features, and productivity tools that help organizations work more efficiently and securely.
                                            </p>
                                        </div>

                                        <div className="topic-item">
                                            <h3>Power Platform</h3>
                                            <p>
                                                Master Power Apps, Power Automate, Power BI, and Power Virtual Agents. Learn to build custom business applications, automate workflows, create insightful dashboards, and develop intelligent chatbots without extensive coding.
                                            </p>
                                        </div>

                                        <div className="topic-item">
                                            <h3>Microsoft Copilot</h3>
                                            <p>
                                                Stay ahead with Microsoft Copilot - the AI-powered assistant that transforms how you work. Learn to leverage Copilot across Microsoft 365 applications to boost productivity, automate tasks, and unlock new capabilities.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="about-approach">
                                    <h2>Our Approach</h2>
                                    <p>
                                        We believe in learning by doing. That's why our content combines:
                                    </p>
                                    <ul>
                                        <li><strong>Video Tutorials:</strong> Step-by-step visual guides that walk you through real-world scenarios</li>
                                        <li><strong>Practical Examples:</strong> Hands-on demonstrations using actual use cases</li>
                                        <li><strong>Best Practices:</strong> Industry-proven methods and tips from experienced professionals</li>
                                        <li><strong>Regular Updates:</strong> Content that stays current with the latest features and updates</li>
                                    </ul>
                                </div>

                                <div className="about-mission">
                                    <h2>Our Mission</h2>
                                    <p>
                                        Our goal is to make Microsoft 365 technologies accessible to everyone, regardless of their technical background. Whether you're a beginner taking your first steps or an experienced professional looking to expand your expertise, you'll find valuable resources to help you succeed.
                                    </p>
                                </div>


                                <div className="about-disclaimer">
                                    <p className="about-disclaimer-text">
                                        This site is an independent educational resource and is not affiliated with, endorsed by, or sponsored by Microsoft.
                                    </p>
                                </div>                                
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default About;

